import {
  booleanAttribute,
  Component,
  Input,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import Session from 'store-management';
import { TRANSLATED_LANGUAGES } from '../../../constants';
import { I18nService } from '../../services/i18n/i18n.service';
import { generateUniqueId } from '../../utils/string';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cohrex-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LanguageSwitcherComponent {
  @ViewChild('languageDropdown') languageDropdown!: NgbDropdown;

  @Input({ transform: booleanAttribute }) showLanguageLabel: boolean = false;

  @Input() uniqueId: string = generateUniqueId();

  session!: Session;
  languages = TRANSLATED_LANGUAGES;
  selectedLanguage = this.languages[0];

  constructor(
    private i18nService: I18nService,
    private translateService: TranslateService
  ) {
    this.session = new Session();

    this.updateLanguage(this.translateService.getCurrentLang());

    this.translateService.onLangChange
      .pipe(takeUntilDestroyed())
      .subscribe((language) => {
        this.updateLanguage(language.lang);
      });
  }

  selectLanguage(code: string) {
    if (code === this.session?.get('locale')) {
      return;
    }
    this.i18nService.setLanguage(code);
    this.languageDropdown.close();
  }

  updateLanguage(code: string) {
    this.selectedLanguage =
      TRANSLATED_LANGUAGES.find((language) => language.code === code) ??
      this.selectedLanguage;
  }
}
